import React from 'react';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import trashTokens from '@amzn/meridian-tokens/base/icon/trash';
import { ERROR_COLOR } from 'src/constants/values';

const DeleteButtonCellRendererNew = (params: { data: unknown; onDelete: (asin: string, zoneName: string) => void }) => {
  const { data, onDelete } = params;

  const onClick = () => {
    const typedData = data as { asin: string; zoneName: string };
    onDelete(typedData.asin, typedData.zoneName);
  };

  return (
    <Button className={ERROR_COLOR} type="icon" onClick={onClick}>
      <Icon tokens={trashTokens} />
    </Button>
  );
};

export default DeleteButtonCellRendererNew;
